module.exports = __webpack_public_path__ + "static/media/Information_icon_flat.svg.ff2cf1e4.png";